import * as React from 'react';
import Container from 'containers/Container';
import Library, {LibraryMode} from 'components/Library';
import {Helmet} from 'react-helmet';

/**
 * The view course page
 * @constructor
 */
export default function ViewCourse(): React.ReactElement {
  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Библиотека</title>
      </Helmet>
      <Container>
        <Library
          mode={LibraryMode.Viewer}
          upload
        />
      </Container>
    </React.Fragment>
  );
}
